import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import useAxios from '../../hooks/useAxios';
import { MESSAGES_SEND_URL, MESSAGES_MARK_READ_URL } from '../../utils/constant';
import { Message } from '../../Models/Message';

interface SendMessageData {
  recipientId: string;
  content: string;
  projectUuid?: string;
}

interface SendMessageResponse {
  success: boolean;
  message?: Message;
  data?: unknown;
}

export function useSendMessage() {
  const { postWithAxios } = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: SendMessageData): Promise<SendMessageResponse> => {
      const response = await postWithAxios(MESSAGES_SEND_URL, {
        recipientUuid: data.recipientId,
        content: data.content.trim(),
        projectUuid: data.projectUuid,
      });
      return {
        success: response?.success ?? false,
        message: response?.data ? new Message(response.data) : (response?.message ? new Message(response.message) : undefined),
        data: response?.data || response?.message,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.messages.conversations() });
      queryClient.invalidateQueries({ queryKey: queryKeys.messages.unreadCount() });
    },
  });
}

export function useMarkAsRead() {
  const { putWithAxios } = useAxios();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (messageId: string) => {
      return putWithAxios(MESSAGES_MARK_READ_URL(messageId), {});
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.messages.unreadCount() });
    },
  });
}
